var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('pill-navigation',{attrs:{"active-item-id":_setup.route.name,"items":_setup.props.items,"theme":_setup.props.theme,"disable-links":""},on:{"change":_setup.navigate}})
}
var staticRenderFns = []

export { render, staticRenderFns }